import 'babel-polyfill' // 解决安卓4.X兼容性问题
import ElementUI from 'element-ui' // 使用element-ui
import 'element-ui/lib/theme-chalk/index.css' // 使用element-ui样式
import './assets/css/common.scss' // 自定义全局样式
import './assets/css/element-reset.scss' // 自定义全局样式
import './assets/css/variables.scss' // 自定义全局样式
import Vue from 'vue'
import App from './App.vue'
import Config from './config' // 配置文件
import Store from './store' // 使用vuex
import Axios from './axios' // 使用axios和mock
import Router from './router' // 使用vue-router
import Directive from './directive' // 自定义指令
import Install from './install' // 全局执行自定义混入等
import Prism from "prismjs"



Vue.use(ElementUI);
Vue.use(Config)
Vue.use(Axios, {mock: false})
Vue.use(Directive)
Vue.use(Install)
Vue.use(Router)
Vue.use(Store)
Vue.use(Prism)

new Vue({
  el: '#app',
  router: Router.router,
  store: Store.store,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js